import { Route } from '@angular/router';

export const organizationRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./organization-list/organization-list.component').then((c) => c.OrganizationListComponent),
  },
];
